/* eslint-disable react-hooks/exhaustive-deps */
import {memo, useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SelectRange, {FIELD_NAME} from '@adv-mt/mt-form-select-range'

const getReversedArray = ({from, to}) =>
  Array(to - from)
    .fill()
    .map((_, i) => to - i)

const DEFAULT_ACTIVE_TAB = 1
const LEGACY_WRAPPER = 'legacy'

const FormYear = ({
  initialSearch,
  isBasicContent = false,
  label,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = {},
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const {DEFAULT_YEAR, DEFAULT_YEAR_MIN, DEFAULT_YEAR_MAX, FILTER_NAMES} = config.get('search')

  const hasLabel = Boolean(label)
  const defaultLabel = i18n.t('COMMON.YEAR')
  const filterLabel = hasLabel ? label : defaultLabel

  const currentValue = {
    from: value.from || DEFAULT_YEAR,
    to: value.to || DEFAULT_YEAR
  }

  const options = useMemo(() => {
    const years = getReversedArray({
      from: DEFAULT_YEAR_MIN,
      to: DEFAULT_YEAR_MAX
    })

    return years.map(year => ({
      id: year,
      label: year
    }))
  }, [])

  return (
    <SelectRange
      defaultActiveTabIndex={DEFAULT_ACTIVE_TAB}
      fieldName={FILTER_NAMES.YEAR}
      initialSearch={initialSearch}
      isBasicContent={isBasicContent}
      label={filterLabel}
      onChange={onChange}
      options={{
        from: {
          name: FIELD_NAME.FROM,
          options
        },
        to: {
          name: FIELD_NAME.TO,
          options
        }
      }}
      overlayContentRef={overlayContentRef}
      pageName={pageName}
      type={type}
      value={currentValue}
      withLabel={withLabel}
      wrapper={wrapper}
    />
  )
}

const FormYearBasicContent = props => <FormYear {...props} isBasicContent />
FormYearBasicContent.displayName = 'FormYearBasicContent'

FormYear.displayName = 'FormYear'
FormYear.propTypes = {
  initialSearch: PropTypes.object,
  isBasicContent: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

const MemoFormYearBasicContent = memo(FormYearBasicContent)
MemoFormYearBasicContent.displayName = 'FormYearBasicContent'

export {MemoFormYearBasicContent as FormYearBasicContent}

export default memo(FormYear)
